import "./GoogleSignInButton.scss";
import { useEffect } from "react";
import { AuthService } from "../../services/auth.service";
import { login } from "../../store/userProfile/userProfileSlice";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useAppDispatch from "../../hooks/useAppDispatch";
import { handleError } from "../../helper/errorHandler";
import { environment } from "../../environment";

declare global {
  interface Window {
    google: any;
  }
}

const GoogleSignInButton = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (window.google) {
      window.google.accounts.id.initialize({
        client_id: environment.googleOAuthClientId,
        callback: handleCredentialResponse,
      });

      window.google.accounts.id.renderButton(document.getElementById("google-signin-button")!, {
        theme: "outline",
      });
    }
  }, []);

  const handleCredentialResponse = (response: any) => {
    const idToken = response.credential;
    googleLogin(idToken);
  };

  const googleLogin = async (idToken: string) => {
    try {
      const response = await AuthService.loginGoogle({ token: idToken });
      if (response?.status === 200) {
        const res = await AuthService.getCurrentUser();
        if (res && res.status === 200) {
          dispatch(login(res.data));
          navigate("/your-location");
        } else {
          handleError(new Error("SOMETHING_WENT_WRONG"), dispatch, t);
        }
      } else {
        handleError(new Error("SOMETHING_WENT_WRONG"), dispatch, t);
      }
    } catch (e) {
      handleError(e, dispatch, t);
    }
  };

  return <div id="google-signin-button" className="google-signin-button" />;
};

export default GoogleSignInButton;
